const ACTION_ITEMS = {
  LOGIN: {
    REQUEST: 'LOGIN_REQUEST',
    SUCCESS: 'LOGIN_SUCCESS',
    FAILURE: 'LOGIN_FAILURE'
  }
};

export default ACTION_ITEMS;



// WEBPACK FOOTER //
// ./src/pages/login/components/loginForm/actionItems.js